import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import PicoLoader from "../Common/PicoLoader";
import Avatar from "./Avatar";
import SingleAvatar from "./SingleAvatar";
import {data} from "../../../Store/Actions/DataAction";
import {connect} from "react-redux";
import blueButton from "../../../assets/images/btn_blue_radius_setting.png";
import DialogContent from "@material-ui/core/DialogContent";
import ShopDialog from "../Common/ShopDialog";
import Dialog from "@material-ui/core/Dialog";
import AvatarBuyDialog from "../Common/AvatarBuyDialog";
import axios from "axios";
import {avatarList, freeGiftRedeem, usersUpdateProfile} from "../../../Utility/Url";
import {
    avatarDialogBackgroundColor, avatarDialogContentColor,
    dialogBackground,
    dialogBorderColor,
    dialogContentColor,
    dialogContentTextColor
} from "../../../Utility/Theme";
import contactUs from "../../../assets/images/contact_us.png";
import Item from "./Item";
import Button from "./Free/Button";
import WoodenInput from "./Free/WoodenInput";
import CardNumber from "../../../assets/images/ic_cardnumber.png";
import CustomDialog from "../Common/Dialog";
import {withRouter} from "react-router-dom";

class ProfileDialog extends React.Component{
    constructor() {
        super();
        this.usernameInput = React.createRef()
        this.cardInput = React.createRef()
        this.state={
            picoSmallLoader:false,
            justify:'flex-end',
            gender:'boy',
            dialogDetail:null,
            showDialog:false
        }
    }
    handleClick=async ()=>{
        this.setState({
            picoSmallLoader:true
        })
        const name=this.usernameInput.current.state.input
        const card=this.cardInput.current.state.input
        await axios.post(usersUpdateProfile,{
            name:name,
            card:card,
        })
            .then(res => {
                this.setState({
                    picoSmallLoader:false
                })
                const {data:{loginData}}=res
                this.props.data(loginData)
                const obg ={
                    dialog:{
                        success:false,
                        cancel:null,
                        message:'اطلاعات با موفقیت ویرایش شد',
                        style: {
                            background: dialogBackground,
                            borderColor: dialogBorderColor,
                            contentColor: dialogContentColor,
                            contentTextColor: dialogContentTextColor,
                            type: "danger",
                        },
                        ok:{
                            action: "#cancel",
                            text: 'باشه'
                        }
                    }
                }
                this.setState({
                    dialogDetail:obg.dialog,
                    showDialog:true,
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.avatars && this.state.picoSmallLoader)
            this.setState({
                picoSmallLoader:false
            })
    }

    handleDialog=(data)=>{
        const obg ={
            dialog:{
                success:false,
                data:data,
                ok:{
                    action: "#cancel",
                    text: 'ثبت!',
                    backgroundColor:'green'
                },
                message:'خرید اواتار',
                style: {

                    background:avatarDialogBackgroundColor ,
                    borderColor: dialogBorderColor,
                    contentColor:avatarDialogContentColor,
                    contentTextColor: dialogContentTextColor,
                    type: "danger",
                },
                cancel:{
                    action: "#cancel",
                    text: 'منصرف شدم!'
                }
            }

        }
        this.setState({
            dialogDetail:obg.dialog,
            showDialog:true
        })
    }
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                })
                window.location.reload()
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    handleInput=(data)=>{
    }
    render() {
        const {avatars}=this.props
        const {justify,gender}=this.state
        const {name,avatar,cardNum}=this.props.UserData.userData.userInfo
        const {dialogDetail,picoSmallLoader}=this.state
        const data= {
            icon:avatar
        }
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogDetail,
            }
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        const dialogTitle= {
            id:'',
            text:'پروفایل',
            icon:'',
            textColor:'#ffffff',
            onClick:''
        }
        const backButton= {
            id:'',
            text:'بازگشت',
            icon:'',
            textColor:'#ffffff',
            onClick:''
        }
        const confirm={
            text:'ثبت',
            backgroundColor:'green',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff'
        }
        const back={
            text:'بازگشت',
            backgroundColor:'purple',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff'
        }
        const cardNumberInput={
            backgroundColor:'transparent',
            layerRadius:'15px',
            inputTextSize:'15px',
            inputMaxLength:'16',
            placeHolder:' ',
            holderImage:CardNumber,
            color:'#fffffff',
            value:cardNum,
            onlyInt:true
        }
        const usernameInput={
            backgroundColor:'transparent',
            layerRadius:'15px',
            inputTextSize:'15px',
            inputMaxLength:'15',
            placeHolder:' ',
            value:name,
            holderImage:CardNumber,
            color:'#fffffff',
        }

        return (
            // <Grid item sm={12} xs={12} alignItems={"center"} justify={'center'} container
            //       style={{backgroundColor:'#3E0448',borderRadius:'20px',border:'2px solid grey',
            //           overflow:'hidden'
            //       }}>
            <Grid item sm={12} xs={12} alignItems={"center"} justify={'center'} container
                  style={{backgroundColor:'#3E0448',
                      overflow:'hidden'
                  }}>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',

                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                <Grid container justify={'space-around'} alignItems={"center"} direction={"column"}>
                    {/*<Grid container xs={12} sm={12} >*/}
                    {/*    <Item data={dialogTitle} toggleIndexNav={this.toggleIndexNav} />*/}
                    {/*</Grid>*/}
                    <Grid container xs={4} sm={4} className='clickable' style={{marginTop:'10px'}}
                          onClick={()=>{
                              this.props.history.push('/settings/avatar')
                          }}
                    >
                        <SingleAvatar data={data}/>
                    </Grid>
                    <Grid container xs={8} sm={8} style={{marginTop:'10px'}}>
                        <WoodenInput input={this.handleInput}  data={usernameInput}  ref={this.usernameInput}/>
                    </Grid>
                    <Grid container xs={8} sm={8} style={{marginTop:'10px'}}>
                        <WoodenInput input={this.handleInput} data={cardNumberInput}  ref={this.cardInput}/>
                    </Grid>
                    <Grid style={{marginTop:'10px'}} sm={11} xs={11} direction={"row-reverse"} container justify={"center"} alignItems={"center"}>
                        <Grid sm={6} xs={6} container alignItems={"center"} justify={"center"}>
                            {
                                !picoSmallLoader&&
                                <Grid sm={12} xs={12} onClick={() => { this.handleClick() }} className='clickable' style={{height:'70px'}}  container alignItems={"center"} justify={"center"}>
                                    <Button  data={confirm}/>
                                </Grid>
                            }
                            {
                                picoSmallLoader &&
                                <Grid sm={5} xs={5} item container justify={"center"} alignItems={"center"}>
                                    <PicoLoader/>
                                </Grid>
                            }
                        </Grid>
                        <Grid className='clickable' style={{height:'70px'}} sm={6} xs={6} container alignItems={"center"} justify={"center"}
                              onClick={()=>{this.props.history.push('/settings')}}
                        >
                            <Button data={back}/>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{data})(withRouter(ProfileDialog))